import React from "react";
import { connect } from "react-redux";
import { AuthSkipAPay } from "../payment-forms/auth-skip-a-pay-form.component";
import { AuthSkipReview } from "../review/auth-skip-review-fields.component";
import { AuthSkipSummary } from "../summary/auth-skip-summary.component";
import { callAuthPostSkip, callGetCardType } from "../../../actions/authPayment.actions";

const SkipAPayFlowComponent = (props) => {
  const { setProcessStep, processStep, selectedLoan, backToLoans } = props;
  const currentForm = props.form["SkipAPay"];

  switch (processStep) {
    case 1:
      return (
        <AuthSkipAPay
          authPayment={props.authPayment}
          setProcessStep={setProcessStep}
          selectedLoan={selectedLoan}
          callGetCardType={props.callGetCardType}
          change={props.change}
          thisForm={currentForm}
          backToLoans={backToLoans}
        />
      );
    case 2:
      return (
        <AuthSkipReview
          thisForm={currentForm}
          authPayment={props.authPayment}
          selectedLoan={selectedLoan}
          callAuthPostSkip={props.callAuthPostSkip}
          setProcessStep={setProcessStep}
          backToLoans={backToLoans}
        />
      );
    case 3:
      return (
        <AuthSkipSummary
          authPayment={props.authPayment}
          selectedLoan={selectedLoan}
          backToLoans={backToLoans}
          thisForm={currentForm}
        />
      );
    case 4:
      return <div>Step 4</div>;
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callAuthPostSkip,
  callGetCardType,
};

const SkipAPayFlow = connect(null, mapDispatchToProps)(SkipAPayFlowComponent);

export default SkipAPayFlow;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/flow-components/skip-a-pay-flow.component.js